import React, { useContext } from 'react';
import LegoAdminPageContext from '../../pages/legoAdminPageContext';
import BadgeId from '../common/BadgeId';
import MiniatureFinder from './MiniatureFinder';
import ScaledMiniature, { useMiniaturesScale } from './ScaledMiniature';

const MINIATURE_SERVICE = '/services/data/model-miniatures';

/**
 * Field editor for a `miniatureId` ObjectId reference. Shows the current id and a button that opens
 * the MiniatureFinder in a (stacked) modal; picking one sets the id. `defaultModelId` pre-filters the
 * finder to the doc's model. Use as a MongoDocEditor extendSchema entry.
 */
export default function MiniatureIdEditor({ value, onChange, defaultModelId = null }) {
  const { page } = useContext(LegoAdminPageContext);
  const pxPerMm = useMiniaturesScale(value ? [value] : [], { maxHeight: 80, maxWidth: 160 });

  const openFinder = () => {
    const svc = page.service(MINIATURE_SERVICE);
    page.openModal(
      <MiniatureFinder
        service={svc}
        defaultModelId={defaultModelId}
        currentId={value}
        onSelect={(id) => { onChange(id); page.closeModal(); }}
      />,
      { title: 'Link a model miniature', minSize: false }
    );
  };

  return <div className={'d-flex align-items-center'}>
    {value
      ? <div className={'d-flex align-items-center'}>
          <span className={'mr-2'}><ScaledMiniature miniatureId={value} pxPerMm={pxPerMm} crop /></span>
          <BadgeId id={value} />
        </div>
      : <span className={'text-muted small'}>No miniature linked</span>}

    <button type={'button'} className={'btn btn-sm btn-outline-primary ml-2'} onClick={openFinder}>
      {value ? 'Change…' : 'Link miniature…'}
    </button>

    {value
      ? <button type={'button'} className={'btn btn-sm btn-outline-danger ml-1'} onClick={() => onChange(null)}>Clear</button>
      : null}
  </div>;
}
